import { render, staticRenderFns } from "./PageBootstrap.vue?vue&type=template&id=614fddde&"
import script from "./PageBootstrap.vue?vue&type=script&lang=js&"
export * from "./PageBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports